import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'circleGreenRed'
})
export class CircleGreenRedPipe implements PipeTransform {
  transform(value: boolean, args?: any): string {
    return value ? 'circleGreen' : 'circleRed';
  }
}
